<template>
  <pl-dialog title="What class is this RoundTable for?" size="md" :disableOutsideClick="true" @close="handleCancelPremade()">
    <div class="h-full w-full px-6 pb-3.5 min-h-1/5 overflow-y-auto overflow-x-hidden">
      <div class="h-full flex flex-col">
        <header id="header-information-course" class="py-5 px-5 border-t border-r border-l border-solid border-gray-200 bg-gray-100 rounded-t-md">
          <div class="flex justify-between items-center">
            <div id="select_course_component" class="flex items-center space-x-3">
              <div class="bg-blueGray-700 rounded-full p-2.5">
                <img src="/static/roundtable_options_create/courses_icon.svg" class="h-4 w-4" alt="course_parlay" />
              </div>
              <div>
                <h5 class="text-base font-poppins text-blueGray-800 font-semibold">
                  Select a Course
                </h5>
              </div>
            </div>
            <div id="search_course">
              <div class="flex items-center space-x-2 bg-white border border-solid border-gray-300 rounded-md w-56 px-3 py-1.5 focus-within:border-blueGray-800">
                <i class="fa-solid fa-magnifying-glass text-gray-700"></i>
                <input
                  placeholder="Search"
                  v-model="searchCourse"
                  class="w-full bg-white text-gray-800 focus-within:border-white border-white"
                />
              </div>
            </div>
          </div>
        </header>
        <main class="overflow-y-auto h-1 flex-grow rounded-b bg-gray-100 border-r border-b border-l border-gray-200 border-solid">
          <ul class="px-5">
            <li
              v-for="(course, index) in coursesFiltered"
              :key="index"
              @click="handleToggleCourse(course)"
              class="flex mb-2 justify-between bg-white px-5 py-3.5 rounded-md hover:border-primary border border-solid border-gray-200 cursor-pointer"
              :class="{
                'border-primary': isCourseSelected(course),
                'opacity-50 cursor-not-allowed': !isCourseSelected(course) && selected_courses.length >= 3
              }"
            >
              <div class="flex items-center space-x-2">
                <h6 class="hover:underline">{{ course.title }}</h6>
                <div class="flex items-center space-x-1.5 text-gray-500 font-light">
                  <span>{{ course.sections[0] }}</span>
                </div>
              </div>
              <Checkbox
                :aria-disabled="!isCourseSelected(course) && selected_courses.length >= 5"
                :is_checked="isCourseSelected(course)"
              />
            </li>
            <div v-if="getCourses.length === 0">
              <div class="flex justify-center items-center mb-1">
                <pl-spinner />
              </div>
              <div class="flex justify-center items-center">
                <span>Loading Courses</span>
              </div>
            </div>
          </ul>
        </main>
        <footer class="mt-3">
          <div class="flex justify-between items-center">
            <div class="flex items-center space-x-2">
              <button
                @click="handleCancelPremade()"
                class="px-6 border border-solid border-coolGray-200 py-2 hover:bg-gray-100 rounded cursor-pointer text-gray-800 :hover:text-gray-900 font-medium disabled:opacity-50"
              >
                Cancel
              </button>
              <Tooltip
                :text="getProfile.activity_passes +' RoundTables left. Click to upgrade account.'"
                positionTooltip="relative"
                styleTooltip="-top-10"
              >
                <button
                  v-if="!getProfile.is_paid"
                  class="inline-flex mr-1.5 hover:text-gray-900 items-center justify-center border border-solid border-coolGray-200 w-10 h-10 text-gray-700 transition-colors duration-150 bg-coolGray-50 rounded focus:shadow-outline hover:bg-coolGray-100"
                  @click="goToUpgradeAccount"
                >
                  <i class="fas fa-rocket text-base text-pinky"></i>
                </button>
              </Tooltip>
            </div>
            <div class="flex items-center space-x-2">
              <button v-if="$route.query.premade_id" @click="handleOpenNewCourseModal()" class="px-4 py-2 hover:bg-gray-100 rounded text-gray-800 border border-solid border-gray-200">
                New Course
              </button>
              <button
                @click="handleCreatePremadeRoundtable()"
                :disabled="selected_courses.length ? false : true"
                class="disabled:opacity-50 flex px-5 py-2 bg-primary border border-solid border-primary hover:border-primary-dark items-center rounded cursor-pointer text-white font-medium"
              >
                <span>{{ isCreating ? 'Creating RoundTable' : 'Create RoundTable' }}</span>
                <div class="loader" v-show="isCreating"></div>
              </button>
            </div>
          </div>
        </footer>
      </div>
    </div>
  </pl-dialog>
</template>

<script>
  import { mapGetters } from 'vuex';
  import store from 'store';
  import Vue from 'vue';
  import findIndex from 'lodash/findIndex';
  import { EventBus } from 'utils/event-bus';
  import roundtableService from 'features/onlineRoundtables/onlineRoundtables.services';
  import getBillingInformation from 'services/account/getBillingInformation';
  import { get } from 'lodash';

  export default Vue.extend({
    components: {
      Tooltip: () => import('../../Tooltip.vue'),
      Checkbox: () => import('../New_RoundTable/Components/Checkbox.vue'),
    },
    props: {
      premadeId: {
        type: String,
        default() {
          return '';
        },
      },
      premadeType: {
        type: String,
        default() {
          return '';
        },
      },
      openAiTitle: {
        type: String,
        default() {
          return '';
        },
      },
      openAiPrompt: {
        type: String,
        default() {
          return '';
        },
      },
    },
    data() {
      return {
        selected_index: null,
        isSelectOpen: false,
        selectedOption: '',
        searchCourse: '',
        selected_course: {},
        selected_courses: [],
        schoolMembership: undefined,
        individualMembership: undefined,
        isCreating: false,
        isLoading: false,
      };
    },
    computed: {
      ...mapGetters([
        'getCourses',
        'getCourseDetail',
        'hasTeacherPermissionsInCourse',
        'getProfile',
      ]),
      courses_I_teach() {
        return this.getCourses.filter((course) => {
          if (course.is_sample !== true && course.is_archived === false) {
            const role = get(course, 'users[0].subscription.role');
            return ['author', 'co-teacher'].includes(role);
          }
        });
      },
      coursesFiltered() {
        let filtered;
        if (this.selectedOption === this.searchCourse)
          return this.courses_I_teach;
        if (!this.searchCourse) return this.courses_I_teach;
        filtered = this.courses_I_teach.filter((course) => {
          if (!course.is_archived) {
            if (
              course.title ||
              course.id !== this.$store.state.course_sample_id
            ) {
              return (
                course.title
                  .toLowerCase()
                  .indexOf(this.searchCourse.toLowerCase()) != -1
              );
            }
          }
        });
        return filtered;
      },
    },
    methods: {
      isCourseSelected(course) {
        return this.selected_courses.some(c => c.id === course.id);
      },
      handleToggleCourse(course) {
        const idx = this.selected_courses.findIndex(c => c.id === course.id);
        if (idx !== -1) {
          this.selected_courses.splice(idx, 1);
          return;
        }
        if (this.selected_courses.length < 3) {
          this.selected_courses.push(course);
        }
      },
      handleOpenNewCourseModal: function() {
        const premadeId = this.$route.query.premade_id;
        localStorage.setItem('premadeId', premadeId);
        this.handleCancelPremade();
        setTimeout(() => {
          EventBus.$emit('open-new-course-modal');
        }, 200);
        
      },
      handleCancelPremade: function () {
        this.$emit('close');
        this.$router.replace({ query: {} });
        localStorage.removeItem('premade_id');
      },
      handleScrollToInput: function () {
        this.$refs.containerCourses.scrollTop = 0;
        this.$refs['searchInput'].focus();
      },
      handleScrollToCourse: function (course_id) {
        const element = document.getElementById(course_id);
        element.scrollIntoView();
      },
      isKeyExists: function (obj, key) {
        obj[key] == undefined ? false : true;
      },
      goToUpgradeAccount: function () {
        this.$emit('close');
        this.$router.push({ name: 'profile.membership' });
        localStorage.removeItem('premade_id');
      },

      handleCreatePremadeRoundtable: async function() {
        if ( this.getProfile.activity_passes === 0 && this.schoolMembership === undefined && this.individualMembership === undefined) {
          return EventBus.$emit('createToast', { type: 'Error', message: 'Sorry! You need upgrade your account!', time: 5000 });
        }

        if (!this.selected_courses.length) {
          return;
        }

        store.dispatch('analytics', 'create written roundtable - create premade roundtable');
        const local_storage_premade_id = localStorage.getItem('premade_id');
        localStorage.removeItem('premade_id');

        this.isCreating = true;

        const createdRoundtables = [];

        for (const course of this.selected_courses) {
          const course_id = course.id;
          const premade_id = this.premadeId || local_storage_premade_id || this.$route.query.premade_id;

          await this.$store.dispatch('fetchCourseDetails', course_id);

          if (this.premadeType === 'online') {
            try {
              const { data: roundtable } = await roundtableService.createRT({course_id, premade_id });

              const default_assessments = [];
              this.getCourseDetail.points_settings.peer_rewards.forEach((criteria) => {
                if (this.isKeyExists(criteria, 'default') === true) {
                  default_assessments.push(criteria);
                }
              });

              store.dispatch('savingRTDetails', {
                id: roundtable.id,
                title: roundtable.title,
                prompt: roundtable.prompt,
                require_submission: roundtable.require_submission,
                enable_annonymous: roundtable.enable_annonymous,
                is_ended: roundtable.is_ended,
                end_date: roundtable.end_date,
                peer_assessment_questions: roundtable.peer_assessment_questions,
                points_settings: default_assessments,
              });

              createdRoundtables.push({courseID: course_id, roundtableID: roundtable.id });
            } catch (err) {
              EventBus.$emit('createToast', { type: 'Error', message: `Something failing adding the roundtable to the next course ${course.title}.`, time: 4000 });
            }
          } else if (this.premadeType === 'live') {
            try {
              const liveDiscussion = await store.dispatch('createLiveDiscussion', { courseID: course_id, premade_id });
              const default_assessments = [];
              this.getCourseDetail.points_settings.peer_rewards.forEach((criteria) => {
                if (this.isKeyExists(criteria, 'default') === true) {
                  default_assessments.push(criteria);
                }
              });
              store.dispatch('saveLiveDiscussionSettings', { id: liveDiscussion.id, title: liveDiscussion.title, points_settings: default_assessments });
              createdRoundtables.push({ courseID: course_id, liveDiscussionID: liveDiscussion.id });
            } catch (err) {
              EventBus.$emit('createToast', { type: 'Error', message: `Something failing adding the roundtable to the next course ${course.title}.`, time: 4000 });
            }
          }
        }

        this.isCreating = false;

        if (createdRoundtables.length) {
          const first = createdRoundtables[0];
          if (first.roundtableID) {
            this.$router.push({ name: 'roundtable.index', params: { courseID: first.courseID, roundtableID: first.roundtableID }, query: { newRT: true } });
          }
          else if (first.liveDiscussionID) {
            this.$router.push({ name: 'live-discussion.index', params: { courseID: first.courseID, liveDiscussionID: first.liveDiscussionID }, query: { newRT: true } });
          }
        }
      },

      /* handleCreatePremadeRoundtable: async function () {
        if (this.getProfile.activity_passes === 0 && this.schoolMembership === undefined && this.individualMembership === undefined) {
          return EventBus.$emit('createToast', { type: 'Error', message: 'Sorry! You need upgrade your account!', time: 5000 });
        }
        store.dispatch('analytics', 'create written roundtable - create premade roundtable');
        const local_storage_premade_id = localStorage.getItem('premade_id');
        localStorage.removeItem('premade_id');
        
        if (this.selected_course.title !== undefined) {
          
          this.isCreating = true;
          const course_id = this.selected_course.id;
          const premade_id = this.premadeId || local_storage_premade_id || this.$route.query.premade_id;

          await this.$store.dispatch('fetchCourseDetails', course_id);
          if (this.premadeType === 'online') {
            roundtableService.createRT({ course_id, premade_id }).then(({ data }) => {
              const roundtable = data;
              let default_assessments = [];
              this.getCourseDetail.points_settings.peer_rewards.map((criteria) => {
                if (this.isKeyExists(criteria, 'default') === true) {
                  default_assessments.push(criteria);
                }
              });
              store.dispatch('savingRTDetails', {
                id: roundtable.id,
                title: roundtable.title,
                prompt: roundtable.prompt,
                require_submission: roundtable.require_submission,
                enable_annonymous: roundtable.enable_annonymous,
                is_ended: roundtable.is_ended,
                end_date: roundtable.end_date,
                peer_assessment_questions: roundtable.peer_assessment_questions,
                points_settings: default_assessments,
              });
              this.isCreating = false;
              this.$router.push({
                name: 'roundtable.index',
                params: { courseID: course_id, roundtableID: roundtable.id },
                query: { newRT: true },
              });
            });
          } else if (this.premadeType === 'live') {
            const liveDiscussion = await store.dispatch('createLiveDiscussion',{ courseID: course_id, premade_id });
            let default_assessments = [];
            this.getCourseDetail.points_settings.peer_rewards.map((criteria) => {
              if (this.isKeyExists(criteria, 'default') === true) {
                default_assessments.push(criteria);
              }
            });
            store.dispatch('saveLiveDiscussionSettings', {
              id: liveDiscussion.id,
              title: liveDiscussion.title,
              points_settings: default_assessments,
            });
            this.isCreating = false;
            this.$router.push({
              name: 'live-discussion.index',
              params: {
                courseID: course_id,
                liveDiscussionID: liveDiscussion.id,
              },
              query: { newRT: true },
            });
          } else if (this.premadeType === 'open-ai') {
            const payload = {
              course_id: course_id,
              title: this.openAiTitle,
              prompt: this.openAiPrompt,
              user_created: true,
              is_generated_by: 'from_genie',
            };
            this.$store.dispatch('createOnlineRoundtable', payload);
          }
        }
      }, */
    },
    mounted: async function () {
      const { course_id } = this.$route.query;
      const membership = await getBillingInformation();
      this.schoolMembership = membership.data.memberships.school_membership;
      this.individualMembership = membership.data.memberships.individual_membership;
      this.$refs['searchInput'].focus();
      if (course_id) {
        this.selected_index = findIndex(this.coursesFiltered, (course) => course.id === course_id);
      }
    },
  });
</script>
<style scoped>
  input[type='radio'] {
    margin-top: 4px;
    width: 16px !important;
    height: 16px !important;
    -webkit-appearance: none;
    -moz-appearance: none;
    -o-appearance: none;
    appearance: none;
    box-shadow: none;
    border-color: #d7d7d7;
    font-size: 0.8rem;
    text-align: center;
    line-height: 1.25rem;
    border-radius: 0.25rem;
    background-color: rgba(243, 244, 246, var(--tw-bg-opacity));
  }
  input[type='radio']:checked {
    background-color: #72ccd7;
    margin-bottom: 5px;
    margin-top: 4px;
    border-color: #72ccd7;
  }
  input[type='radio']:checked::after {
    font-family: 'Font Awesome 5 Free';
    content: '\f00c';
    font-weight: 900;
    color: white;
    line-height: 1.25rem;
  }
  .loader,
  .loader:after {
    border-radius: 50%;
    width: 20px;
    height: 20px;
    margin-left: 12px;
    margin-top: 1px;
  }
  .loader {
    border-top: 3px solid rgba(255, 255, 255, 0.2);
    border-right: 3px solid rgba(255, 255, 255, 0.2);
    border-bottom: 3px solid rgba(255, 255, 255, 0.2);
    border-left: 3px solid #ffffff;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-animation: load8 1.1s infinite linear;
    animation: load8 1.1s infinite linear;
  }
  @-webkit-keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// newPremadeModal.vue?40ddff3b